export default __webpack_public_path__ + "static/media/flame.48c62b25.svg";